import { Alert, Button } from '@factorialco/deprecated-design-system'
import {
  ExternalAccessPageItemFragment,
  ExternalAccessesPageQueryDocument,
} from 'generated/resources/graphql'

import Modal from 'modules/core/components/Modal'
import { ClosePortalFn } from 'modules/core/components/Portal/useCloseProxy'
import useAsyncAction from 'modules/core/hooks/useAsyncAction'
import { useQuery } from 'modules/core/hooks/useQuery'
import i18n from 'modules/core/lib/i18n'
import app from 'modules/core/store/models/app'

import { useDeactivateAccess } from 'modules/external_users/hooks/useDeactivateExternalUser'

interface Props {
  access: ExternalAccessPageItemFragment
  onClose: React.ComponentProps<typeof Modal>['onClose']
}

const DeactivateExternalAccessModal = ({ access, onClose }: Props) => {
  const { loading, deactivate } = useDeactivateAccess({
    onCompleted(data) {
      app.setProgress(null)
      if (data.apiCoreMutations.deactivateApicoreAccess?.errors.length) {
        app.setFlash({
          type: 'wrong',
          message: i18n.t('settings.external_users.actions.deactivate_user.error'),
        })
        return
      }
    },
  })

  // FIXME: Make editing these accesses a GQL mutation so we don't need to refetch
  const { refetch } = useQuery(ExternalAccessesPageQueryDocument)

  const { running, performAction: onSubmit } = useAsyncAction(
    async (closePortal: ClosePortalFn) => {
      await deactivate({
        id: access.id,
      })
      await refetch()

      closePortal()
    }
  )

  return (
    <Modal
      illustration="alert"
      title={i18n.t(
        'settings.external_users.actions.deactivate_user.confirm_external_deactivate.title'
      )}
      description={i18n.t(
        'settings.external_users.actions.deactivate_user.confirm_external_deactivate.description'
      )}
      onClose={onClose}
      onSubmit={onSubmit}
      footer={
        <>
          <Button disabled={loading} onClick={onClose} type="secondary">
            {i18n.t('common.cancel')}
          </Button>
          <Button disabled={running} type="negative" submit>
            {i18n.t('settings.external_users.actions.deactivate_user.action')}
          </Button>
        </>
      }
    >
      <Alert color="warning">
        {i18n.t(
          'settings.external_users.actions.deactivate_user.confirm_external_deactivate.alert'
        )}
      </Alert>
    </Modal>
  )
}

export default DeactivateExternalAccessModal
